import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { callAPI, IsSmallScreen, Method, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import ConfirmDialog, { useConfirmDialog } from "../../../Components/Confirmation/ConfirmDialog";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../../Components/DataGrid/WSMobileDataGridAdvanced";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../../StateManagement/actions";


export const DealList: React.FC<any> = React.memo((props) => {
    AllPermissions.getInstance();
    const { add, edit, remove, view } = AllPermissions.getDealPermission;
    const { showMessage } = useSnackbar();
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [dealListData, setDeallistData] = useState<any>([])
    const isMobile = IsSmallScreen();
    const { open, title, onConfirm, handleClose, openConfirmDialog, } = useConfirmDialog();
    const [totalCount, setTotalCount] = useState<any>(0);
    useEffect(() => {
        updateMainHeader("Deals");

        breadCrumbsStore.updateBreadCrumbs([
            { "Deals": "" },


        ]);
    });
    const source = {
        url: "leads/search",
        page: 1,
        pageSize: 10,
        filter: [
            {
                "field": "leadType",
                "operator": "eq",
                "value": "0"
            }
        ],
        sort: [],
    };


    useEffect(() => {

        const getDeals = async () => {
            try {

                const response: any = await callAPI('deals', Method.GET, null, null);
                setTotalCount(response?.length || 0)
                setDeallistData(response || []);
            }
            catch (e) {

            }
        }
        getDeals();
    }, [])
    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/deal/edit/${row?.id}`)
        }
        else if (action === "Delete") {
            openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
        }
    };
    const handleDelete = async (id?: string | number) => {
        const response: any = await callAPI(`deals`, Method.DELETE, null, id);
        dispatch(resetDataComponent('productListGrid'));
      if (response?.success) {
      showMessage(response?.message, "success")
    }
    else {
      showMessage(response?.message || 'Something went wrong', "error")
    }
        handleClose()

    };
    const columns: IColumns[] = [
        {
            header: "Deal Name",
            fieldName: "dealName",
            tooltip: true,
            type: 'default',

        },
        {
            header: "stage",
            fieldName: "stage",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Amount",
            fieldName: "amount",
            tooltip: true,
            type: 'default'
        },
        {
            header: "status",
            fieldName: "status",
            tooltip: true,
            type: 'status'
        },

        {
            header: "closeDate",
            fieldName: "closeDate",
            tooltip: true,
            type: 'date'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined, remove ? "Delete" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const mobColumns: IOrderColumns[] = [
        {
            header: "Deal Name",
            fieldName: "dealName",
            tooltip: true,
            type: 'default',
            labelSx: { fontWeight: 'bold' }
        },
        {
            header: "stage",
            fieldName: "stage",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Amount",
            fieldName: "amount",
            tooltip: true,
            type: 'default'
        },

        {
            header: "closeDate",
            fieldName: "closeDate",
            tooltip: true,
            type: 'date'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];

    const handleClick = () => {
        navigate('/deal/create')
    }
    return (
        <>
            <Grid container spacing={2}>
                {view ? <Grid item xs={12}>
                    {!isMobile && <WSDataGrid
                        id="dealMainListGrid"
                        title="Deals"
                        columns={columns}
                        data={dealListData}
                        addButton={add ? { label: "New", color: "secondary" } : undefined}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />
                    }
                    {isMobile &&
                        <WSMobileDataGridAdvanced title={'Deals'} addButton={add ? { label: "New", color: "secondary" } : undefined}
                            onAddButtonClick={handleClick} columns={mobColumns} id="dealMainListGrid" source={source} />
                    }
                </Grid>
                    : <PermissionDenied />}
                <ConfirmDialog
                    open={open}
                    title={title}
                    onConfirm={onConfirm}
                    onClose={handleClose}
                />
            </Grid>
        </>
    )
})